import { Pill } from 'components/pill/Pill';

export interface ApiKeyScopePillProps {
  label: string;
}

export const ApiKeyScopePill: React.FC<ApiKeyScopePillProps> = ({ label }) => {
  return <Pill color="muted">{label}</Pill>;
};
